import { errorInterceptor } from './error/error.interceptor';
import { headersInterceptor } from './headers/headers.interceptor';
import { removeNullsInterceptor } from './remove-nulls/remove-nulls.interceptor';

export const httpInterceptorProviders = [
  headersInterceptor,
  errorInterceptor,
  removeNullsInterceptor,
];
